module.exports = __webpack_public_path__ + "static/Group5997@2x-c9ca959b5e3f22396cf34e9f672fa62b.png";